import type { LayoutData } from "@ServerTypes/layoutView/layoutView.schema";

/**
 * Reads the ordered module-id list stored on a project-dashboard layout view (`data.modules`),
 * dropping any non-string entries. Shared by the sidebar, the dashboard module cards, and the
 * configure-layout modal so this parsing lives in exactly one place.
 */
export function getLayoutModuleIds(layout: LayoutData | null | undefined): string[] {
  const rawModules = layout?.data?.modules;
  return Array.isArray(rawModules) ? rawModules.filter((module): module is string => typeof module === "string") : [];
}
